export enum PackageType {
  CYPRUS = 'Cyprus',
}
